<pureui-svg class="status-icon" *ngIf="svg" [svg]="svg" [height]="height"></pureui-svg>
